import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 83 80"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2FAE0C",
  "fill-rule": "evenodd",
  d: "M78.917 40v-3.225c0-2.15-1.433-3.584-3.584-3.584-2.15 0-3.583 1.434-3.583 3.584V40c0 17.916-14.333 32.25-32.25 32.25C21.584 72.25 7.25 57.916 7.25 40c0-17.917 14.334-32.25 32.25-32.25 4.658 0 8.959 1.075 13.258 2.866 1.792.717 3.942 0 4.659-1.791.716-1.792 0-3.942-1.792-4.659C50.608 1.658 44.875.583 39.5.583A39.303 39.303 0 0 0 .083 40 39.303 39.303 0 0 0 39.5 79.416 39.303 39.303 0 0 0 78.917 40ZM76.409 5.24c1.433-1.433 3.583-1.433 5.016 0 1.434 1.434 1.434 3.584 0 5.017L42.01 49.675c-.717.716-1.792 1.075-2.509 1.075-.717 0-1.791-.359-2.508-1.075l-10.75-10.75c-1.434-1.434-1.434-3.584 0-5.017 1.433-1.433 3.583-1.433 5.017 0L39.5 42.15 76.41 5.24Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }